import Quill, { Delta } from 'quill/core';
import type { Range } from 'quill/core';
import type { Blot } from '../types';

const applyBlockFormat = (
  quill: Quill,
  parentQuill: Quill,
  blot: Blot,
  format?: { name: string; value?: unknown } | null,
  range: Range = quill.getSelection(true),
) => {
  const lines = quill.getLines(range.index, range.length || 1);
  const lineOffsetStart = lines[0]?.offset(quill.scroll);
  const lastLine = lines[lines.length - 1];
  const lineOffsetEnd =
    lastLine && lastLine.offset(quill.scroll) + lastLine.length();

  if (
    typeof lineOffsetStart !== 'number' ||
    typeof lineOffsetEnd !== 'number'
  ) {
    return;
  }

  const blotOffset = blot.offset(parentQuill.scroll);
  // @ts-expect-error
  const value = new Delta(blot.value()['code-embed']);
  let delta = new Delta().retain(blotOffset);
  let advancedIndex = 1;
  if (lineOffsetStart === 0) {
    delta.delete(1);
    advancedIndex -= 1;
  } else {
    delta.retain({
      'code-embed': new Delta()
        .retain(lineOffsetStart)
        .delete(value.length() - lineOffsetStart).ops,
    });
  }

  const attributes = format ? { [format.name]: format.value } : undefined;
  value.slice(lineOffsetStart, lineOffsetEnd).eachLine((line) => {
    delta = delta.concat(line.insert('\n', attributes));
  });

  const restValue = value.slice(lineOffsetEnd);
  if (restValue.length()) {
    delta.insert({ 'code-embed': restValue.ops });
  }
  parentQuill.updateContents(delta, Quill.sources.USER);
  parentQuill.setSelection(
    blotOffset + advancedIndex + range.index - lineOffsetStart,
    range.length,
    Quill.sources.SILENT,
  );
};

export default applyBlockFormat;
